import Image, { ImageProps } from 'next/image';

export function Glyph(props: Omit<ImageProps, 'alt' | 'src'> & { name: string }) {
  const { name, ...imageProps } = props;
  return (
    <Image alt='' height={64} src={`https://uds-assets.udacity.com/glyphs/v2/${name}.svg`} width={64} {...imageProps} />
  );
}
